// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sEOa","textarea":"styles_textarea__F64Ak"};